/** Jules / AI Help entitlement helpers. */

export const AI_HELP_SUBSCRIPTION_LEVELS = ['pro', 'ai', 'enterprise'];

export const DEFAULT_JULES_EVENT_CLASS_PRIORITY = [
	'sports_teams',
	'holidays',
	'local_festivals',
	'national_events',
	'provincial_events',
	'global_events',
	'awareness_days',
];

export const JULES_EVENT_CLASS_LABELS = {
	sports_teams: 'Sports teams',
	holidays: 'Holidays',
	local_festivals: 'Local festivals',
	national_events: 'National events',
	provincial_events: 'Provincial / state events',
	global_events: 'Global events',
	awareness_days: 'Awareness days',
};

/**
 * User may use Jules when:
 * - subscription_active and subscription_level in allowlist, OR
 * - roles or features includes "ai_help"
 */
export function canUseAiHelp(user) {
	if (!user) return false;

	const features = Array.isArray(user.features) ? user.features : [];
	const roles = Array.isArray(user.roles) ? user.roles : [];
	if (features.includes('ai_help') || roles.includes('ai_help')) {
		return true;
	}

	if (user.subscription_active === true) {
		const level = String(user.subscription_level || '').toLowerCase().trim();
		if (AI_HELP_SUBSCRIPTION_LEVELS.includes(level)) {
			return true;
		}
	}

	return false;
}

/** System has Jules editor suggestions / autonomous mode available. */
export function isJulesEnabledOnSystem(system) {
	return !!(system && system.aiHelpEnabled === true);
}

/** Autonomous daily picks require master opt-in + Let Jules decide. */
export function canJulesDecide(system) {
	return isJulesEnabledOnSystem(system) && system.letJulesDecide === true;
}

export function normalizeEventClassPriority(priority) {
	const seen = new Set();
	const out = [];
	const source = Array.isArray(priority) && priority.length
		? priority
		: DEFAULT_JULES_EVENT_CLASS_PRIORITY;
	for (const id of source) {
		if (typeof id !== 'string' || !id || seen.has(id)) continue;
		if (!JULES_EVENT_CLASS_LABELS[id] && !DEFAULT_JULES_EVENT_CLASS_PRIORITY.includes(id)) continue;
		seen.add(id);
		out.push(id);
	}
	for (const id of DEFAULT_JULES_EVENT_CLASS_PRIORITY) {
		if (!seen.has(id)) {
			seen.add(id);
			out.push(id);
		}
	}
	return out;
}

/** Parse "HH:mm" local time; returns { hours, minutes } or null. */
export function parseJulesTime(value) {
	if (typeof value !== 'string') return null;
	const m = value.trim().match(/^(\d{1,2}):(\d{2})$/);
	if (!m) return null;
	const hours = Number(m[1]);
	const minutes = Number(m[2]);
	if (!Number.isFinite(hours) || !Number.isFinite(minutes)) return null;
	if (hours < 0 || hours > 23 || minutes < 0 || minutes > 59) return null;
	return { hours, minutes };
}

export function formatJulesTime({ hours, minutes }) {
	return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
}
